import './IconDate.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconDate = _ref => {
  let {
    width = 20,
    height = 20,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16762",
    "data-name": "Group 16762",
    transform: "translate(-1630 -1177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M20,4H18V2H16V4H8V2H6V4H4A2,2,0,0,0,2,6V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,16H4V12H20Zm0-10H4V6H6V8H8V6h8V8h2V6h2Z",
    transform: "translate(1628 1175)",
    fill: "#035e88"
  })));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "sxbka9x"
});
export default IconDate;